<template>
      
  <div class="pb-5" v-if="props.contextMenu == true" @contextmenu.prevent>
    <nav>
      <Tree 
        :value="state.treeData" 
        :filter="true" 
        filterMode="lenient"
        selectionMode="single"
        @node-select="clickRow"
      >
        <template #default="slotProps">
          <span
            class="col_summary"
            v-if="slotProps.node.data.editable != 'Y'"
          >
            {{ slotProps.node.label }}
          </span>
          <ElInput
            v-else
            ref="editInputRef"
            v-model="slotProps.node.data[props.idNm]"
            @inputBlur="changeDeptNm(slotProps.node.data)"
            @inputKeyupEnter="r=>r.target.blur()"
          />
        </template>
      </Tree>

    </nav>

    
  </div>

  <div class="pb-5" v-else>
    <nav>
      <Tree 
        :value="state.treeData" 
        :filter="true" 
        filterMode="lenient"
        selectionMode="single"
        @node-select="clickRow"
      >
      <template #default="slotProps">
          <span
            ref="treeSpanRef"
            :class="[slotProps.node.data.clickYn == 'Y' ? 'tree-text-bg' : '']"
            v-if="slotProps.node.data.editable != 'Y'"
          >
            {{ slotProps.node.label }}
          </span>

          <ElInput
            v-else
            ref="editInputRef"
            :modelValue="slotProps.node.data[props.idNm]"
            @inputBlur="changeDeptNm(slotPromenuListps.node.data)"
            @inputKeyupEnter="r=>r.target.blur()"
            @update:modelValue="updateVal"
          />
          
        </template>
      </Tree>
        
    </nav>

    
  </div>

  
  <vue-simple-context-menu
    v-if="props.contextMenu == true"
    element-id="myUniqueId"
    :options="state.options"
    ref="contextMenu"
    @contextmenu.prevent
    @option-clicked="optionClicked"
    @clickRow="r=>clickRow(r)"
  />

</template>

<script setup>
import { reactive,watch,ref, nextTick } from 'vue';
import VueSimpleContextMenu from 'vue-simple-context-menu';
import Tree from 'primevue/tree';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';

const contextMenu = ref()
const treeRef = ref()
const editInputRef = ref()
const treeSpanRef = ref()
const props = defineProps({
  menuList: {
    type: Array,
    required: false,
    default : []
  },
  contextMenu: {
    type: Boolean,
    required: false,
    default : false
  },
  parentId : String,
  id : String,
  idNm : String,
  rootVal : String,
})

const emits = defineEmits(['return','addRow','updateRow','deleteRow'])
const state = reactive({
    selectedData : [],
    treeData : [],
    options : [
        {
          name: 'add',
          slug: 'add',
        },
        {
          name: 'addChild',
          slug: 'addChild',
        },
        {
          name: 'edit',
          slug: 'edit',
        },
        {
          name: 'delete',
          slug: 'delete',
        },
    ],
    updateList : [],
    selectedData : {}
})

// onMounted(()=>{
//   sortData()
// })

watch(
    () => props.menuList ,(newVal,oldVal)=>{
        sortData()
    },
)

const cellRightClick = (event, item) => {
  let data = {
    event: event,
    item: item,
  };
  handleClick(data)
  // emits("openContextMenu", data);
};



//json 1차원 데이터 트리 다중 차원으로 재배열(시작지점 추출)
const sortData = () =>{

    let rootList = []
    

    //근원지(root) == 0 먼저 추출

    for (let item of props.menuList) {
      if (item[props.parentId] == props.rootVal) {
        let row = {
          key: item[props.id],
          data: item,
          label : item[props.idNm],
          editCell: {},
        };
        rootList.push(row);
      }
    }
    //child 찾기
    rearrange(rootList)
    state.treeData = [...rootList]


}

//(재귀함수)자식이 있을경우 계속 depth 생성 로직
const rearrange = (rootList) => {
  for (let item of rootList) {
    let childTree = [];
    props.menuList.filter((i, index) => {
      if (i[props.parentId] == item.key) {
        let row = {
          key: i[props.id],
          data: i,
          label : i[props.idNm],
          editCell: {},
        };
        childTree.push(row);
      }
    });

    if (childTree?.length > 0) {
      item.children = childTree;
      rearrange(childTree);
    }
  }
}

//마우스 우클릭 시 contextmenu 오픈 함수
const handleClick = (data)=>{
    if(props.contextMenu){
      contextMenu.value.showMenu(data.event, data.item)
    }
}

//contextmenu에 옵션 클릭 시 실행 함수
const optionClicked = (item) => {
  if(item.item && item.item != undefined && item?.item != null ){
    item.item.option = {
      slug : ''
    }
    item.item.option.slug = item.option.slug 
    item = item.item
  }
 

  let row = new Object()

  //row 생성
  if(item.option.slug =='add'){
    if(confirm('정말 등록하시겠습니까?')){
      row[props.id] = ''
      row[props.parentId] = item[props.parentId] ? item[props.parentId] : ''
      row[props.idNm] = 'new row'
      emits('addRow',row)
    }
  }
  //자식 row 생성
  else if(item.option.slug =='addChild'){

    row[props.id] = ''
    row[props.parentId] = item[props.id] || ''
    row[props.idNm] = 'new row'
    emits('addRow',row)

  }
  //row 수정
  else if(item.option.slug =='edit'){

    changeEnable(item[props.id])

  }
  //row 삭제
  else if(item.option.slug =='delete'){
    if(item.children && item.children?.length > 0){
      alert('하위 항목이 존재한 부서는 삭제가 불가능합니다.')
      return
    }
    emits('deleteRow',item)
  }
}



//자신 및 자식 인덱스 삭제
const deleteRows = (dept_id) => {
  for(let [index,item] of props.menuList.entries()){
    
    if(item.dept_id == dept_id){          //자신일 경우
      props.menuList.splice(index,1)
      let data = {
        dept_name : item.dept_name,
        dept_id : item.dept_id,
        parent_id : item.parent_id,
        status : 'delete'
      }

      item.status = 'delete'
      state.updateList.push(item)

    }else if(item.parent_id == dept_id){ //삭제하는키에 해당하는 부모일경우
      let data = {
        dept_name : item.dept_name,
        dept_id : item.dept_id,
        parent_id : item.parent_id,
        status : 'delete'
      }
      props.menuList.splice(index,1)
      item.status = 'delete'
      state.updateList.push(item)
    }

  }
  //트리 재구성
  sortData()
} 

//context menu edit 클릭시 속성값변경 -> input 태그 변환 조건파람
const changeEnable = async(id) =>{
  for(let item of props.menuList){
    if(item[props.id] == id){
      item.editable = 'Y'
    }
  }
  await nextTick()
  if(editInputRef.value){
    editInputRef.value.input.focus()
  }

  //트리 재구성
  // sortData()
}

//row edit 후 값 변경 완료했을 경우 실행 함수 
const changeDeptNm = (item) => {
  //중복일경우 이름만 변경
  item.editable = 'N'
  emits('return',item)
  emits('updateRow',item)
 
  
}


//클릭시 부모페이지 부서 상세정보 전달
const clickRow = async(event) =>{
  for(let i of props.menuList){
    i.clickYn = 'N'
  }

  await nextTick()
  if(event.children == undefined || event?.children.length == 0){
    event.data.clickYn = 'Y'
  }
  state.selectedData = event.data
  emits('return',event.data)
}

// 부모페이지의 등록,수정,삭제 버튼 클릭 시 실행 함수
const clickRowCRUD = (status) => {

  if(!state.selectedData.option){
    state.selectedData.option = {slug:status}
  }else{
    state.selectedData.option.slug = status
  }
  optionClicked(state.selectedData)
}

//최종 변경된 row들 반환
const getUpdateList = () => {
  return state.updateList
}

const searchItem = (codeList)=>{
  let code = ''
  let index = 0
  treeRef.value.searchItem(codeList,code,index)
}

const updateVal = (val,data)=>{

  data[props.idNm] = val
}

const clickItem = async(data)=>{
  for(let i of props.menuList){
    i.clickYn = 'N'
  }

  await nextTick()
  if(data.children == undefined || data?.children.length == 0){
    data.data.clickYn = 'Y'
  }
}


defineExpose({
  clickRowCRUD,
  getUpdateList,
  searchItem,
  state
})
</script>
